var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"6","viewBox":"0 0 9 6","fill":"none"}},[_c('path',{class:_vm.light ? 'icon-color__fill--lighten5' : 'icon-color__fill--primary',attrs:{"d":"M9 0.75L4.5 5.25L0 0.750001L9 0.75Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }